import React from 'react'
import { Row, Col, Container} from 'react-bootstrap'
import Accordion from 'react-bootstrap/Accordion'
import styled from 'styled-components'
import AnimationContainer from 'components/animation-container'
import { Helmet } from 'react-helmet';


class Digicert extends React.Component {

    shouldComponentUpdate() {
        return false
    }

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({height: window.innerHeight})
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({width: window.innerWidth})
        }
    }

    
    componentDidMount() {
        this.setState({height: window.innerHeight, width: window.innerWidth})
        window.addEventListener('resize', this.updateDimensions)
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }
      
    render() {        

        // Datos estructurados para preguntas y respuestas
        const PreguntasRespuestas = {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
                {
                    "@type": "Question",
                    "name": "¿Qué es SiteLock Security?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "SiteLock es una empresa líder en seguridad cibernética que ofrece soluciones de protección web diseñadas para proteger sitios web contra una variedad de amenazas cibernéticas, como malware, vulnerabilidades, ataques de delincuentes informáticos y otras formas de actividad maliciosa. Fundada en 2008, SiteLock se ha convertido en un proveedor confiable de seguridad en línea para empresas de todos los tamaños, desde pequeñas empresas hasta grandes corporaciones. Las soluciones de SiteLock incluyen escaneo y eliminación de malware, protección contra ataques de denegación de servicio distribuido (DDoS), firewall de aplicaciones web (WAF), monitoreo de vulnerabilidades, prevención de botnets y mucho más. Estas soluciones están diseñadas para ser fáciles de implementar y gestionar, lo que permite a los propietarios de sitios web proteger sus activos en línea de manera efectiva sin requerir conocimientos técnicos avanzados."
                    }
                },
                {
                    "@type": "Question",
                    "name": "¿Qué es inyección SQL?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "La inyección SQL es una técnica común utilizada por los delincuentes cibernéticos para atacar bases de datos a través de vulnerabilidades en aplicaciones web. Esta técnica explota fallos de seguridad en la entrada de datos de una aplicación web que interactúa con una base de datos. Cuando un sitio web recibe datos de entrada de un usuario, como formularios de inicio de sesión o campos de búsqueda, estos datos pueden ser manipulados por un atacante para introducir código SQL malicioso en las consultas que la aplicación web realiza a la base de datos. Si la aplicación no está correctamente protegida contra esta vulnerabilidad, el atacante puede ejecutar consultas SQL no autorizadas y potencialmente obtener acceso no autorizado a la base de datos, modificar su contenido o incluso eliminar datos sensibles."
                    }
                },
                {
                    "@type": "Question",
                    "name": "¿Qué es ataque XSS?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "El ataque XSS, abreviatura de Cross-Site Scripting (o script entre sitios en español), es una técnica de ataque común en la que un atacante inserta scripts maliciosos en páginas web visitadas por otros usuarios. Estos scripts pueden ser ejecutados en el navegador de los usuarios que visitan la página comprometida, lo que permite al atacante robar información confidencial, como cookies de sesión, datos personales o credenciales de inicio de sesión, o incluso realizar acciones en nombre del usuario sin su consentimiento."
                    }
                }
                // Otras preguntas y respuestas...
            ]
        }
          
        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #fff;
            padding: 150px 0 50px 0;
            .heading {
                width: 100%;            
            @media (max-width: 767px) {
                padding: 10px 0 50px 0;           
            }
            @media (min-width:768px) and (max-width:1500px) {
                padding: 100px 0 50px 0;              
            }
        `

        const ServiceRow = styled(Row)`
            margin-top: 1px;
        `
        const ServiceRow1 = styled(Row)`
            margin-top: 10px;
        `
         
        const TecText = styled.p`
            font-size: 18px;
            font-weight: 300;
            color: #4c4c4c !important;            
        `        
        
        const Text = styled.p`
        font-size: 17px;
        font-family: roboto,sans-serif;
        color: #777;        
        `        
        
        const ServiceList = styled.ul`
            padding: 0;
            margin: 11px 0 0 0;
        `

        const ServiceListElement = styled.li`
            list-style: none;
            color: #000;
            font-weight: 300;
            font-size: 17px;
            font-family: roboto,sans-serif;
            margin: 5px 0px;
            &::before {
                display: inline-block;
                content: '';
                border-radius: 2.5px;
                height: 5px;
                width: 5px;
                margin-right: 10px;
                background-color:#78c91c;
                position: relative;
                bottom: 2.5px;
            }
        `
        const Color3 = styled.span`          
          color: #40a832;
          font-family: "Teko", sans-serif;            
        `

        const Heading2 = styled.h2`
            transform: translate(0, -100px);            
            transition: 1s;
            margin: 100px 0 -30px 0;            
            font-size: 70px;
            line-height: 80px;
            font-family: "Teko", sans-serif;
            font-weight: bold;
            color: #000;
            text-align: center;
            @media (max-width: 767px) {
                font-size: 50px;
                line-height: 60px;
                margin: 50px 0 -30px 0;
            }
        `

        return(
            <Section id="QA">
                <Container>
                    {/* Llama al componente PreguntasRespuestas directamente */}
                    <Helmet>
                        <script type="application/ld+json">
                            {JSON.stringify(PreguntasRespuestas)}
                        </script>
                    </Helmet>

                    <Heading2><Color3>SiteLock,</Color3> Herramienta de seguridad Web</Heading2>
                    <ServiceRow>
                        <Col md={12}>
                            <TecText>
                                No pongas en riesgo la seguridad de tu tienda online ni la confianza de tus clientes.
                            </TecText>
                        </Col>

                    </ServiceRow>
                    <ServiceRow1>
                        <Col md={12}>
                            <AnimationContainer animation="fadeInDown" delay={500}>
                                <Accordion defaultActiveKey="0">
                                    {/* Item 0 */}
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>
                                            ¿Qué es SiteLock Security?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Text>SiteLock es una empresa líder en seguridad cibernética que ofrece soluciones de protección web diseñadas para proteger sitios web contra una
                                                variedad de amenazas cibernéticas, como malware, vulnerabilidades, ataques de delincuentes informáticos y otras formas de actividad maliciosa. Fundada en 2008,
                                                SiteLock se ha convertido en un proveedor confiable de seguridad en línea para empresas de todos los tamaños, desde pequeñas empresas hasta
                                                grandes corporaciones.
                                            </Text>
                                            <Text>Las soluciones de SiteLock incluyen escaneo y eliminación de malware, protección contra ataques de denegación de servicio distribuido (DDoS),
                                                firewall de aplicaciones web (WAF), monitoreo de vulnerabilidades, prevención de botnets y mucho más. Estas soluciones están diseñadas para
                                                ser fáciles de implementar y gestionar, lo que permite a los propietarios de sitios web proteger sus activos en línea de manera efectiva
                                                sin requerir conocimientos técnicos avanzados.
                                            </Text>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {/* Item 1 */}
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>
                                            ¿Qué es inyección SQL?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Text>
                                                La inyección SQL es una técnica común utilizada por los delincuentes cibernéticos para atacar bases de datos a través de vulnerabilidades en aplicaciones web. Esta
                                                técnica explota fallos de seguridad en la entrada de datos de una aplicación web que interactúa con una base de datos. Cuando un sitio web recibe
                                                datos de entrada de un usuario, como formularios de inicio de sesión o campos de búsqueda, estos datos pueden ser manipulados por un atacante para
                                                introducir código SQL malicioso en las consultas que la aplicación web realiza a la base de datos. Si la aplicación no está correctamente protegida
                                                contra esta vulnerabilidad, el atacante puede ejecutar consultas SQL no autorizadas y potencialmente obtener acceso no autorizado a la base de
                                                datos, modificar su contenido o incluso eliminar datos sensibles.
                                            </Text>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {/* Item 2 */}
                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header>
                                            ¿Qué es ataque XSS?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Text>
                                                El ataque XSS, abreviatura de Cross-Site Scripting (o script entre sitios en español), es una técnica de ataque común en la que un atacante inserta scripts
                                                maliciosos en páginas web visitadas por otros usuarios. Estos scripts pueden ser ejecutados en el navegador de los usuarios que visitan la página comprometida,
                                                lo que permite al atacante robar información confidencial, como cookies de sesión, datos personales o credenciales de inicio de sesión, o incluso realizar
                                                acciones en nombre del usuario sin su consentimiento.
                                            </Text>
                                            <Text>
                                                Hay varios tipos de ataques XSS, incluidos:
                                            </Text>
                                            <ServiceList>
                                                <ServiceListElement>
                                                    XSS Reflejado: En este tipo de ataque, el código malicioso se inyecta en un sitio web y se refleja en el navegador de la víctima cuando visita esa página
                                                    comprometida a través de un enlace malicioso, un mensaje de correo electrónico o una URL manipulada.
                                                </ServiceListElement>
                                                <ServiceListElement>
                                                    XSS Almacenado: En este caso, el código malicioso se almacena en la base de datos de un sitio web, como en un campo de entrada de texto o un comentario en
                                                    un foro, y se ejecuta cuando otros usuarios acceden a la página que muestra el contenido comprometido.
                                                </ServiceListElement>
                                                <ServiceListElement>
                                                    XSS Basado en DOM (Document Object Model): Este tipo de ataque aprovecha vulnerabilidades en el código JavaScript de una página web para modificar el DOM
                                                    y ejecutar código malicioso en el navegador del usuario.
                                                </ServiceListElement>
                                            </ServiceList>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {/* Item 3 */}
                                    <Accordion.Item eventKey="3">
                                        <Accordion.Header>
                                            ¿Qué es Malware?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Text>
                                                El malware es un término que se utiliza para referirse a software malicioso diseñado para infiltrarse o dañar una computadora o sistema informático sin el
                                                consentimiento del usuario. El término "malware" es una combinación de las palabras "malicioso" y "software".
                                            </Text>
                                            <Text>
                                                Existen muchos tipos diferentes de malware, cada uno con sus propósitos y métodos de operación. Algunos ejemplos comunes de malware incluyen:
                                            </Text>
                                            <ServiceList>
                                                <ServiceListElement>
                                                    Virus: Programas informáticos diseñados para infectar archivos y programas, replicándose a sí mismos y propagándose a otras computadoras. Los virus pueden
                                                    causar daños al sistema, como corromper archivos o ralentizar el rendimiento de la computadora.
                                                </ServiceListElement>
                                                <ServiceListElement>
                                                    Gusanos (Worms): Similar a los virus, los gusanos se propagan de una computadora a otra, pero no necesitan infectar archivos. Se replican y se transmiten
                                                    a través de redes informáticas, aprovechando vulnerabilidades en el software y el sistema operativo.
                                                </ServiceListElement>
                                                <ServiceListElement>
                                                    Troyanos (Trojans): Programas maliciosos que se disfrazan como software legítimo para engañar a los usuarios y hacer que descarguen e instalen el malware.
                                                    Los troyanos pueden permitir a los atacantes acceder y controlar remotamente la computadora infectada, robar información confidencial o instalar otro
                                                    software malicioso.
                                                </ServiceListElement>
                                                <ServiceListElement>
                                                    Ransomware: Un tipo de malware que cifra archivos en la computadora de la víctima y exige un rescate para restaurar el acceso a ellos. El ransomware puede
                                                    causar pérdidas significativas de datos y afectar negativamente a individuos y organizaciones.
                                                </ServiceListElement>
                                                <ServiceListElement>
                                                    Spyware: Software diseñado para recopilar información sobre las actividades de un usuario sin su conocimiento o consentimiento. El spyware puede registrar
                                                    pulsaciones de teclado, capturar pantallas, robar contraseñas y otra información confidencial.
                                                </ServiceListElement>
                                                <ServiceListElement>
                                                    Adware: Programas que muestran anuncios no deseados en la computadora del usuario. Aunque no siempre son dañinos, el adware puede ralentizar el rendimiento
                                                    del sistema y ser molesto para el usuario.
                                                </ServiceListElement>
                                            </ServiceList>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {/* Item 4 */}
                                    <Accordion.Item eventKey="4">
                                        <Accordion.Header>
                                            ¿Qué es un CDN?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Text>
                                                Un CDN, o Red de Distribución de Contenidos (Content Delivery Network en inglés), es una red de servidores distribuidos geográficamente que trabajan juntos para
                                                entregar de manera eficiente contenido web a los usuarios finales. El objetivo principal de un CDN es mejorar el rendimiento, la velocidad y la disponibilidad
                                                de los sitios web al reducir la latencia y minimizar la carga en el servidor de origen.
                                            </Text>
                                            <Text>
                                                Cuando un usuario solicita acceder a un sitio web, el CDN selecciona automáticamente el servidor más cercano al usuario en función de su ubicación geográfica.
                                                Este servidor, llamado "punto de presencia" (PoP), almacena una copia en caché del contenido del sitio web, como imágenes, videos, archivos CSS y JavaScript.
                                            </Text>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    {/* Item 5 */}
                                    <Accordion.Item eventKey="5">
                                        <Accordion.Header>
                                            ¿Qué es un certificado SSL de servidor seguro?
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Text>
                                                Los certificados SSL (Secure Sockets Layer), también conocidos como certificados de servidor seguro, son pequeños archivos de datos que se instalan en un servidor
                                                web para establecer una conexión segura cifrada entre el servidor y el navegador del usuario. Estos certificados son esenciales para la seguridad en línea al
                                                proteger la información confidencial transmitida entre el navegador del usuario y el servidor web.
                                            </Text>
                                            <Text>
                                                Cuando un usuario visita un sitio web protegido con un certificado SSL, el protocolo SSL/TLS (Transport Layer Security) crea una conexión segura cifrada entre
                                                el navegador del usuario y el servidor web. Esto garantiza que cualquier información transmitida, como datos personales, contraseñas o información de pago,
                                                esté protegida contra el acceso no autorizado durante la transferencia.
                                            </Text>
                                            <Text>
                                                Los certificados SSL también autentican la identidad del propietario del sitio web, lo que proporciona a los usuarios la confianza de que están interactuando
                                                con un sitio web legítimo y no un sitio falso o fraudulento. Esto se logra mediante la verificación de la autenticidad del dominio y la organización
                                                propietaria del sitio por parte de la autoridad de certificación que emite el certificado SSL.
                                            </Text>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </AnimationContainer>
                        </Col>
                    </ServiceRow1>
                </Container>
            </Section>
        )
    }

}

export default Digicert